import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductInfo from '../components/ProductInfo';
import RelatedProducts from '../components/RelatedProducts';
import { allProductsData } from '../data/products';
import useSEO from '../hooks/useSEO';
import './ProductDetailsPage.css';

const ProductDetailsPage = () => {
    const { id } = useParams();

    // Find the product by ID (convert useParams string to Number)
    const product = allProductsData.find(p => p.id === Number(id));

    useEffect(() => {
        // Scroll to top when navigating to a new product
        window.scrollTo(0, 0);
    }, [id]);

    const canonicalUrl = product ? `https://www.primerehabindustries.in/product/${product.id}` : undefined;
    const pageTitle = product
        ? `${product.title} | ${product.category} | Prime Rehab Industries`
        : "Product Not Found | Prime Rehab Industries";
    const pageDescription = product
        ? (product.description ? product.description.slice(0, 160) : `${product.title} - ${product.category} manufactured by Prime Rehab Industries, Chennai.`)
        : "The equipment you are looking for could not be found on Prime Rehab Industries.";

    const productSchema = product ? [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.primerehabindustries.in/" },
                { "@type": "ListItem", "position": 2, "name": "Products", "item": "https://www.primerehabindustries.in/products" },
                { "@type": "ListItem", "position": 3, "name": product.title, "item": canonicalUrl }
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.title,
            "image": product.gallery && product.gallery.length ? product.gallery : [product.image],
            "description": product.description,
            "category": product.category,
            "brand": { "@type": "Brand", "name": "Prime Rehab Industries" },
            "manufacturer": { "@type": "Organization", "name": "Prime Rehab Industries", "url": "https://www.primerehabindustries.in/" }
        }
    ] : undefined;

    useSEO({
        title: pageTitle,
        description: pageDescription,
        canonical: canonicalUrl || "https://www.primerehabindustries.in/products",
        robots: product ? "index, follow" : "noindex, follow",
        image: product ? product.image : undefined,
        schema: productSchema
    });

    if (!product) {
        return (
            <div className="product-details-page">
                <Navbar />
                <main className="product-details-content product-not-found">
                    <h2>Product Not Found</h2>
                    <p>The equipment you are looking for does not exist. <a href="/products">View all products</a>.</p>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div className="product-details-page">
            <Navbar />

            <main className="product-details-content">
                <ProductInfo product={product} />
                <RelatedProducts currentProductId={product.id} />
            </main>

            <Footer />
        </div>
    );
};

export default ProductDetailsPage;
